export const GET_FEATURED_LIST = "@@MINDSETS/GET_FEATURED_LIST";
export const GET_FEATURED_LIST_REQUEST = "@@MINDSETS/GET_FEATURED_LIST_REQUEST";
export const GET_FEATURED_LIST_SUCCESS = "@@MINDSETS/GET_FEATURED_LIST_SUCCESS";
export const GET_FEATURED_LIST_FAILURE = "@@MINDSETS/GET_FEATURED_LIST_FAILURE";

export const SET_USER_SUB = "@@MINDSETS/SET_USER_SUB";
export const RESET_USER_SUB = "@@MINDSETS/RESET_USER_SUB";
